import React, {useState} from 'react';
import {Helmet} from "react-helmet";
import {Portlet, PortletBody, PortletHeader, PortletHeaderToolbar} from "../../../components/Portlet";
import axios from "../../../helpers/axios";
import {noDispHeader} from "../../../helpers/errorTranslate";
import sayError from "../../../helpers/sayError";
import {useForm} from "react-hook-form";
import {Form, Tab, Table, Tabs} from "react-bootstrap";
import LoadingButton from "../../base/components/loadingButton";
import _ from "lodash";
import numberFormat from "../../../helpers/numberFormat";
import CustomDatePicker from "../../base/components/forms/customDatePicker";
import moment from "moment/moment";

const EInvoicesCheck = () => {
  const [data, setData] = useState()
  const [loading, setLoading] = useState(false)
  const formController = useForm()
  const {register, handleSubmit} = formController
  const defaultVal = {
    start: moment().subtract(1, 'months').format('DD.MM.YYYY'),
    end: moment().format('DD.MM.YYYY')
  }

  const onSubmit = (data) =>{
    setLoading(true)
    const sendData = new FormData()
    sendData.append('file', data.file[0])
    sendData.append('start', data.start)
    sendData.append('end', data.end)
    axios.post('/api/racoon/pdfParse/checkOneCPortal', sendData,{headers: {
        'Content-Type':"application/x-www-form-urlencoded"}})
      .then(({data})=>{
        console.log('datafile', data)
        setData(data)
      })
      .finally(()=>setLoading(false))
  }
  return (
    <>
      <Helmet>
        <title>Сверка ЭСФ</title>
      </Helmet>
      <Portlet>
        <PortletHeader title={'Сверка ЭСФ'} toolbar={<PortletHeaderToolbar>
          <form onSubmit={handleSubmit(onSubmit)} className={'d-flex gap-2 align-items-center'}>
            <CustomDatePicker formController={formController}
                              label={"Дата c"}
                              value={defaultVal.start}
                              name={`start`}
                              rules={{required: true}}/>
            <CustomDatePicker formController={formController}
                              label={"Дата по"}
                              value={defaultVal.end}
                              name={`end`}
                              rules={{required: true}}/>
            <Form.Control
              type={"file"}
              accept={'.xlsx'}
              multiple={false}
              {...register('file', {required: true})}
            />
            <LoadingButton loading={loading} title={'Сравнить'}/>
          </form>
        </PortletHeaderToolbar>}/>
          {data && <PortletBody className={'pt-1'}>
            <div>
              <b>{numberFormat(data.total1C)}</b> - В 1с <br/>
              <b>{numberFormat(data.totalPortal)}</b> - В в ИС ЭСФ
            </div>
            <Tabs defaultActiveKey="correct">
              <Tab
                eventKey="correct"
                title={<div>
                  Правильные ({data.revise.correct.length})
                </div>}
              >
                <Table striped hover bordered>
                  {renderHeader()}
                  {renderStandartBody(data.revise.correct)}
                </Table>
              </Tab>
              <Tab
                eventKey="oneCMissing"
                title={<div>
                  Нет в 1с ({data.revise.oneCMissing.length})
                </div>}
              >
                <Table striped hover bordered>
                  {renderHeader()}
                  {renderStandartBody(data.revise.oneCMissing)}
                </Table>
              </Tab>
              <Tab
                eventKey="portalMissing"
                title={<div>
                  Нет в ИС ЭСФ ({data.revise.portalMissing.length})
                </div>}
              >
                <Table striped hover bordered>
                  {renderHeader()}
                  {renderStandartBody(data.revise.portalMissing)}
                </Table>
              </Tab>
              <Tab
                eventKey="diff"
                title={`Отличаются (${data.revise.diff.length})`}
              >
                <Table striped bordered hover>
                  <thead>
                  <tr>
                    <td rowSpan={2}>Дата выписки</td>
                    <td rowSpan={2}>Номер документа</td>
                    <td rowSpan={2}>Дата оборота</td>
                    <td className={'text-center'} colSpan={3}>
                      Итог
                    </td>
                  </tr>
                  <tr className={'text-center'} >
                    <td>1с</td>
                    <td>ИС ЭСФ</td>
                    <td>Разница</td>
                  </tr>
                  </thead>
                  <tbody>
                  {data.revise.diff.map((row,index)=>{
                    return <tr key={index}>
                      <td>{row.issueDate}</td>
                      <td>{row.ticketNumber}</td>
                      <td>{row.turnoverDate}</td>
                      <td className={'text-center'}>{numberFormat(row.summNds.oneC)}</td>
                      <td className={'text-center'}>{numberFormat(row.summNds.portal)}</td>
                      <td className={'text-center'}>{numberFormat(Math.abs(row.summNds.oneC - row.summNds.portal))}</td>
                    </tr>
                  })}
                  </tbody>
                </Table>
              </Tab>
              {data.revise.oneCDuplicates.length> 0 &&<Tab
                eventKey="oneCDuplicates"
                title={<div>
                  Дублирующиеся в 1с ({data.revise.oneCDuplicates.length})
                </div>}
              >
                <Table striped hover bordered>
                  {renderHeader()}
                  {renderStandartBody(data.revise.oneCDuplicates)}
                </Table>
              </Tab>}
              {data.revise.portalDuplicates.length> 0 &&<Tab
                eventKey="oneCDuplicates"
                title={<div>
                  Дублирующиеся в ИC ЭСФ ({data.revise.portalDuplicates.length})
                </div>}
              >
                <Table striped hover bordered>
                  {renderHeader()}
                  {renderStandartBody(data.revise.portalDuplicates)}
                </Table>
              </Tab>}

            </Tabs>
          </PortletBody>}
      </Portlet>

    </>
  );
};

export default EInvoicesCheck;

const renderHeader = () => {
  return <thead>
  <tr>
    <td>Дата выписки</td>
    <td>Номер документа</td>
    <td>Дата оборота</td>
    <td className={'text-end'}>Сумма НДС</td>
  </tr>
  </thead>
}

const renderStandartBody = (array) => {
  return <tbody>
  {array.map((row, index) => {
    return <tr key={index}>
      <td>{row.issueDate}</td>
      <td>{row.ticketNumber}</td>
      <td>{row.turnoverDate}</td>
      <td className={'text-end'}>{numberFormat(row.summNds)}</td>
    </tr>
  })}
  <tr>
    <th colSpan={3}>
      Итого
    </th>
    <th className={'text-end'}>{numberFormat(_.sumBy(array, 'summNds'))}</th>
  </tr>
  </tbody>
}
